/* ========================================
   Custom Section — Full Width Image
   Full-width image with optional caption
   ======================================== */

window.sectionRenderers = window.sectionRenderers || {};

window.sectionRenderers.fullWidthImage = function(data) {
  if (!data.imageUrl) return '';
  return '<div class="cs-full-width">' +
    '<div class="cs-full-width__media">' +
      '<img src="' + escapeHtml(data.imageUrl) + '" alt="" loading="lazy">' +
    '</div>' +
    (data.caption ? '<p class="cs-full-width__caption">' + escapeHtml(data.caption) + '</p>' : '') +
  '</div>';
};
